import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnInit,
} from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-generic-tabs',
    templateUrl: './generic-tabs.component.html',
    styleUrls: ['./generic-tabs.component.scss'],
    imports: [NgFor, NgIf],
})
export class GenericTabsComponent implements OnInit {
  @Input() public tabData: TabData[] = [];

  @Output() private readonly selectedTab = new EventEmitter<string>();

  public pages: TabData[][] = [];

  public currentPage = 0;

  public currentTabs: TabData[] = [];

  public longTitleCutoff = 18;

  @ViewChild('tabsContainer', { static: false }) tabsContainerRef!: ElementRef;

  ngOnInit(): void {
    this.paginateTabs();
    this.getCurrentPageTabs();
  }

  paginateTabs() {
    this.pages = [];
    const tabsPerPage = 3;

    if (this.tabData.length <= 4) {
      this.pages.push(this.tabData);
    } else {
      let i = 0;
      while (i < this.tabData.length) {
        this.pages.push(this.tabData.slice(i, i + tabsPerPage));
        i += tabsPerPage;
      }
    }
  }

  getCurrentPageTabs(): void {
    const tabs = [...this.pages[this.currentPage]];

    if (this.currentPage > 0) {
      tabs.unshift({
        title: '',
        id: 'left-arrow',
        isActive: false,
        isArrow: true,
      });
    }
    if (this.currentPage < this.pages.length - 1) {
      tabs.push({
        title: '',
        id: 'right-arrow',
        isActive: false,
        isArrow: true,
      });
    }
    // fill empty space on last page
    if (this.tabData.length > 4 && this.currentPage === this.pages.length - 1) {
      const placeholdersToAdd = 4 - tabs.length;
      tabs.push(
        ...Array.from({ length: placeholdersToAdd }, (_, i) => ({
          title: '',
          id: `placeholder-${i}`,
          isActive: false,
        }))
      );
    }

    this.currentTabs = tabs;
  }

  public onTabClicked(tab: TabData): void {
    if (tab.id === 'left-arrow') {
      this.onNavigate('left');
    } else if (tab.id === 'right-arrow') {
      this.onNavigate('right');
    } else {
      this.tabData.forEach((tabElement) => {
        // eslint-disable-next-line no-param-reassign
        tabElement.isActive = false;
      });
      // eslint-disable-next-line no-param-reassign
      tab.isActive = true;
      this.selectedTab.emit(tab.id);
    }
  }

  onNavigate(direction: 'left' | 'right'): void {
    if (direction === 'left' && this.currentPage > 0) {
      this.currentPage -= 1;
    } else if (
      direction === 'right' &&
      this.currentPage < this.pages.length - 1
    ) {
      this.currentPage += 1;
    }
    this.getCurrentPageTabs();
  }
}

export interface TabData {
  title: string;
  id: string;
  isActive: boolean;
  isArrow?: boolean;
}
